function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require = require('@uppy/core'),
    Plugin = _require.Plugin;

var Translator = require('@uppy/utils/lib/Translator');

var Compressor = require('compressorjs/dist/compressor.common.js');

var UppyImageCompressor =
/*#__PURE__*/
function (_Plugin) {
  _inheritsLoose(UppyImageCompressor, _Plugin);

  function UppyImageCompressor(uppy, opts) {
    var _this;

    _this = _Plugin.call(this, uppy, opts) || this;
    _this.id = _this.opts.id || 'ImageCompressor';
    _this.type = 'modifier';
    _this.defaultLocale = {
      strings: {
        compressingImages: 'Compressing images...'
      }
    };
    var defaultOptions = {
      quality: 0.6
    };
    _this.opts = _extends({}, defaultOptions, opts); // we use those internally in `this.compress`, so they
    // should not be overriden

    delete _this.opts.success;
    delete _this.opts.error;

    _this.i18nInit();

    _this.prepareUpload = _this.prepareUpload.bind(_assertThisInitialized(_this));
    _this.compress = _this.compress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = UppyImageCompressor.prototype;

  _proto.setOptions = function setOptions(newOpts) {
    _Plugin.prototype.setOptions.call(this, newOpts);

    this.i18nInit();
  };

  _proto.i18nInit = function i18nInit() {
    this.translator = new Translator([this.defaultLocale, this.uppy.locale, this.opts.locale]);
    this.i18n = this.translator.translate.bind(this.translator);
    this.setPluginState(); // so that UI re-renders and we see the updated locale
  };

  _proto.compress = function compress(blob) {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      new Compressor(blob, _extends({}, _this2.opts, {
        success: function success(result) {
          return resolve(result);
        },
        error: function error(err) {
          return reject(err);
        }
      }));
    });
  };

  _proto.prepareUpload = function prepareUpload(fileIDs) {
    var _this3 = this;

    var promises = fileIDs.map(function (fileID) {
      var file = _this3.uppy.getFile(fileID);

      _this3.uppy.emit('preprocess-progress', file, {
        mode: 'indeterminate',
        message: _this3.i18n('compressingImages')
      });

      if (file.type.split('/')[0] !== 'image') {
        return;
      }

      return _this3.compress(file.data).then(function (compressedBlob) {
        _this3.uppy.log("[Image Compressor] Image " + file.id + " size before/after compression: " + file.data.size + " / " + compressedBlob.size);

        _this3.uppy.setFileState(fileID, {
          data: compressedBlob
        });
      })["catch"](function (err) {
        _this3.uppy.log("[Image Compressor] Failed to compress " + file.id + ":", 'warning');

        _this3.uppy.log(err, 'warning');
      });
    });

    var emitPreprocessCompleteForAll = function emitPreprocessCompleteForAll() {
      fileIDs.forEach(function (fileID) {
        var file = _this3.uppy.getFile(fileID);

        _this3.uppy.emit('preprocess-complete', file);
      });
    }; // Why emit `preprocess-complete` for all files at once, instead of
    // above when each is processed?
    // Because it leads to StatusBar showing a weird “upload 6 files” button,
    // while waiting for all the files to complete pre-processing.


    return Promise.all(promises).then(emitPreprocessCompleteForAll);
  };

  _proto.install = function install() {
    this.uppy.addPreProcessor(this.prepareUpload);
  };

  _proto.uninstall = function uninstall() {
    this.uppy.removePreProcessor(this.prepareUpload);
  };

  return UppyImageCompressor;
}(Plugin);

module.exports = UppyImageCompressor;
